import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import history from '@AppRoutes/history';
import { paths, loginRelatedPaths } from '@AppRoutes/constants';
import Catalyst from '@Services/Catalyst';

import { Button } from '@els/els-react--button';

import './NotAnonShibbolethLogin.scss';

function NotAnonShibbolethLogin({ isShibbolethUser, onRegisterClick, onSignInClick }) {
  const [pathname, setPathname] = useState(history.location.pathname);
  useEffect(() => history.listen((location) => setPathname(location.pathname)), []);
  const isLoginPage = pathname === '/login';
  const isRegisterPage = pathname === '/register' || pathname === '/security/register';
  const isLoginOrOrgRoute = loginRelatedPaths.includes(pathname);

  // On any login/organization-related screen, route to the full login/register pages instead of opening modals.
  const handleRegisterClick = isLoginOrOrgRoute
    ? () => {
        Catalyst.trackConversionDriverClick('header:register');
        history.push({ pathname: paths.REGISTER });
      }
    : onRegisterClick;
  const handleSignInClick = isLoginOrOrgRoute
    ? () => {
        Catalyst.trackConversionDriverClick('header:sign-in');
        history.push({ pathname: paths.LOGIN });
      }
    : onSignInClick;

  return (
    <>
      {!isShibbolethUser && (
        <li className="u-els-padding-left-2x u-els-display-none@tablet">
          <Button
            data-e2e="header-register"
            id="header-register"
            className="e2e-header-register"
            type="primary"
            active={isRegisterPage}
            disabled={isRegisterPage}
            onClick={handleRegisterClick}>
            Register
          </Button>
        </li>
      )}
      <li className="u-els-padding-left-1x u-els-display-flex u-els-display-none@tablet">
        <Button
          id="not-anon-shibbo-sign-in"
          className={`u-els-color-n8 u-els-font-size-h4 rx-no-wrap${isLoginPage ? ' not-anon-sign-in--active' : ''}`}
          data-e2e="not-anon-sign-in"
          type="borderless"
          disabled={isLoginPage}
          onClick={handleSignInClick}
          href="#"
          aria-label="Sign in">
          Sign in
        </Button>
      </li>
    </>
  );
}

NotAnonShibbolethLogin.propTypes = {
  isShibbolethUser: PropTypes.bool,
  onRegisterClick: PropTypes.func.isRequired,
  onSignInClick: PropTypes.func.isRequired,
};

export default NotAnonShibbolethLogin;
